import { render, staticRenderFns } from "./TgBetContent.vue?vue&type=template&id=15ecc234"
import script from "./TgBetContent.vue?vue&type=script&lang=js"
export * from "./TgBetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports